import * as React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import HtmlHead from '@components/HtmlHead'
import { withRouter } from 'next/router'
import { GlobalStyle, H160, P18 } from '@components/shared'
import { colors } from '@components/shared/colors'
import TopNav from '@components/TopNav'
import { Container, Col, Row, config } from 'react-awesome-styled-grid'
import ReadyToListen from '@components/ReadyToListen'
import type { AppStateType } from '../../reducers/appstate'
import TopNavMobile from '@components/TopNavMobile'
import type { SubscriptionLengthType } from '../../flowTypes'
import BackgroundGradient from '@components/BackgroundGradient'

type PropsType = {
  isGift: boolean,
  subscriptionLength: SubscriptionLengthType
}

function RedeemConfirmed (props: PropsType): React.ReactNode {
  let subscriptionLengthText

  if (props.isGift) {
    if (props.subscriptionLength === 'monthly') {
      subscriptionLengthText = 'You were gifted a month of unlimited access.'
    } else if (props.subscriptionLength === 'annual') {
      subscriptionLengthText = 'You were gifted a year of unlimited access.'
    } else if (props.subscriptionLength === 'six_months') {
      subscriptionLengthText = 'You were gifted 6 months of unlimited access.'
    }
  }

  return (
    <ContainerDiv>
      <BackgroundGradient quadrant={3} />
      <HtmlHead
        title={'Dipsea | Redeem'}
        description={'Get unlimited access to short, sexy audio stories, wellness sessions, and sleep scenes. Choose your subscription plan and start listening.'}
      />
      <GlobalStyle backgroundColor={colors.midnightBlue}/>
      <TopNav backgroundColor={colors.midnightBlue95} isAssetLoaded={true}/>
      <TopNavMobile backgroundColor={colors.midnightBlue95} isAssetLoaded={true}/>
      <Container>
        <Row>
          <Col align={'center'}>
            <HeaderContainer>
              <H160 color={colors.white} textAlign={'center'}>{'You’ve just unlocked a world of spicy audiobooks'}</H160>
              {subscriptionLengthText && (
                <HeaderTextContainer>
                  <P18Copy color={colors.white} textAlign={'center'}>{subscriptionLengthText}</P18Copy>
                </HeaderTextContainer>
              )}
              <HeaderTextContainer>
                <P18Copy color={colors.white} textAlign={'center'}>{'Now, log into the app for 1000+ spicy audiobooks, romance novels, sleep scenes, steamy sounds, and more.'}</P18Copy>
              </HeaderTextContainer>
            </HeaderContainer>
          </Col>
        </Row>
        <Row align='center' justify='center'>
          <Col align={'center'} xs={3} sm={6} md={4} lg={5} xl={4}>
            <ReadyToListenContainer>
              <ReadyToListen title={'Ready to listen?'} color={colors.sand}/>
            </ReadyToListenContainer>
          </Col>
        </Row>
      </Container>
    </ContainerDiv>
  )
}

const mapStateToProps = (state: AppStateType): { isGift: any, subscriptionLength: any } => {
  return {
    isGift: state.user?.subscription_type === 'gift',
    subscriptionLength: state.user?.subscription_length
  }
}

export default withRouter(connect(mapStateToProps, {})(RedeemConfirmed) as any) as any

const ContainerDiv = styled.div<any>`
  width: 100%;
`
const HeaderContainer = styled.div<any>`
  z-index: 1;
  margin-top: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
`

const HeaderTextContainer = styled.div<any>`
  z-index: 1;
  margin-top: 15px;
  width: 80%;
`

const ReadyToListenContainer = styled.div<any>`
  z-index: 1;
  background-color: ${colors.midnightBlue};
  border-radius: 26px;
  display: flex;
  justifying-content: center;
  align-items: center;
  padding: 36px 22px;
  margin: 60px 0px 60px 0px;
  width: 100%;
`
const P18Copy = styled(P18)<any>`
${(props: any): any => config(props).media.lg`
   white-space: pre;
`}
`
